export default __webpack_public_path__ + "assets/db80d973afb018be3987066a4c0a106a.jpg";